import React, { Component } from 'react';
import '../css/App.css';
import '../css/fonts.css';
import '../css/addlightness.css';

/*
import cloud1 from '../img/cloud1.png'
import cloud2 from '../img/cloud2.png'
import cloud3 from '../img/cloud3.png'
*/


export class FutoSpec extends Component {
  constructor(props) {
    super(props)

    this.state = {
      //showDescription: false,
      showDescription: true,
    }

    this.hovered = this.hovered.bind(this)
    this.unHovered = this.unHovered.bind(this)

    this.renderAppDescriptionBox = this.renderAppDescriptionBox.bind(this)
  }


  hovered(elem) {
    console.log("Futo Spec hovered()")
    this.setState({ showDescription: true })
  }

  unHovered(elem) {
    this.setState({ showDescription: false })
  }

  renderAppDescriptionBox() {
    //console.log("renderAppDescriptionBox()")
    const description = "Custom test runner / Cucumber TDD replacement. Keep running notes as you code, then turn those raw notes into useable integration tests."
    return (
      <div className='idea-description'>
        { description }
      </div>
    )
  }


  render() {

    return (
      <div className="idea-container">
        <div className='idea-row'>
          <div className="idea-row-item">
            <div className="idea-box">
              <a href="https://seanfelipe.github.io/automation/test-engine/frameworks/cucumber/2020/05/30/futo-spec.html">
              Futo-Spec
              </a>
            </div>
          </div>

          <div className="idea-row-item">
            <div className="tool-description-container">
              { this.state.showDescription
                ? this.renderAppDescriptionBox()
                : null
              }
            </div>
            </div>
        </div>
      </div>
    )
  }
}
